exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mybutton{display:none}.button{float:right;height:unset;position:relative!important}image{max-width:80px!important}.thead-tr-danger{background-color:red}table.b-table[aria-busy=true]{opacity:.6}tbody>tr>td>a>div>div>span>p{margin:0!important}.table-stjawhite{vertical-align:middle!important}.table-primarystja,.table-stjawhite{padding:0!important;padding-left:15px!important;text-align:left}th.table-primarystja>div:first-child,th.table-stjawhite>div:first-child{padding-top:15px;padding-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ea207000","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AngTabelle.vue
// module id = 628
// module chunks = 0